import { render, staticRenderFns } from "./MeteorShower.vue?vue&type=template&id=0a2d8f36&scoped=true&"
import script from "./MeteorShower.vue?vue&type=script&lang=js&"
export * from "./MeteorShower.vue?vue&type=script&lang=js&"
import style0 from "./MeteorShower.vue?vue&type=style&index=0&id=0a2d8f36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2d8f36",
  null
  
)

export default component.exports